import { Component, OnInit } from '@angular/core';
import { ClientService } from '../../core/services/client.service';
import { CommonModule, NgFor } from '@angular/common';
import { TableComponent } from '../../shared/components/table/table.component';
import { RouterModule } from '@angular/router';
import { NewButtonComponent } from '../../shared/components/new-button/new-button.component';
import { TableColumn } from '../../core/models/column.model';
import { Client } from '../../core/models/client.model';
import { ConfirmPopupComponent } from '../../shared/components/confirm-popup/confirm-popup.component';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatButtonModule } from '@angular/material/button';
import { ClientDetailComponent } from '../client-detail/client-detail.component'; // Importa ClientDetailComponent

@Component({
  selector: 'app-client-list',
  templateUrl: './client-list.component.html',
  styleUrls: ['./client-list.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    TableComponent,
    RouterModule,
    NewButtonComponent,
    ConfirmPopupComponent,
    MatPaginatorModule,
    MatSortModule,
    MatTableModule,
    MatButtonModule,
    ClientDetailComponent,
  ], // Agrega ClientDetailComponent
})
export class ClientListComponent implements OnInit {
  clients: any[] = [];
  clientToDelete: Client | null = null;
  selectedClient: Client | null = null; // Variable para el cliente seleccionado
  tableColumns: TableColumn[] = [
    { header: 'ID', field: 'id' },
    { header: 'Rut', field: 'rut' },
    { header: 'Razon Social', field: 'razonSocial' },
    { header: 'Estado', field: 'disabled' },
    { header: 'Fecha', field: 'createdUtc', isDate: true },
  ];

  constructor(private clientService: ClientService) {}

  ngOnInit(): void {
    this.getClients();
  }

  getClients(): void {
    this.clientService.getClients().subscribe(clients => (this.clients = clients));
  }

  confirmDelete(client: Client) {
    this.clientToDelete = client;
  }

  onDeleteConfirm() {
    if (this.clientToDelete) {
      this.clientService.deleteClient(this.clientToDelete.id!).subscribe(() => {
        this.getClients();
        this.clientToDelete = null;
      });
    }
  }

  onDeleteCancel() {
    this.clientToDelete = null;
  }

  toggleClientStatus(client: Client) {
    client.disabled = !client.disabled;
    this.clientService.disabledClient(client).subscribe(() => {
      this.getClients();
    });
  }

  selectClient(client: Client) {
    this.selectedClient = client; // Asigna el cliente seleccionado
  }

  closeClientDetail() {
    this.selectedClient = null; // Cierra el detalle del cliente
  }
}
